import { getDefaultClient } from '../../../client/defaultClient';
import { getWalletProviders } from '../getWalletProviders';
import type { WalletProviderData } from '../walletProvider';

/**
 * Retrieves data for all available wallet providers that can be used for connection.
 *
 * This function returns metadata about wallet providers that users can
 * connect to, like MetaMask, Phantom, etc.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns An array of wallet provider data including chain, keys, and metadata.
 */
export const getAvailableWalletProvidersData = (
  client = getDefaultClient()
): WalletProviderData[] => {
  const allWalletProviders = getWalletProviders(client);

  // This is to avoid returning the wallet providers that are connected via different means
  // than by the "connect" method — like the Dynamic Waas providers, AA providers, or WalletConnect providers.
  const filteredWalletProviders = allWalletProviders.filter((walletProvider) =>
    Boolean(walletProvider.connect)
  );

  return filteredWalletProviders.map((walletProvider) => ({
    chain: walletProvider.chain,
    groupKey: walletProvider.groupKey,
    key: walletProvider.key,
    metadata: walletProvider.metadata,
    walletProviderType: walletProvider.walletProviderType,
  }));
};
